/**
 * Volleyball set-score helpers. Games store per-set points in
 * `game.setScores` ([{home, away}, ...]) while `homeScore`/`awayScore` hold
 * SETS WON — one derivation, used by BOTH the admin score-entry UI (live
 * preview) and any server path that persists setScores, so the stored
 * sets-won can never disagree with the sets.
 */

export interface SetScore {
  home: number;
  away: number;
}

export interface SetsWon {
  home: number;
  away: number;
}

/**
 * Sets won per side. A set counts for whichever side has strictly more
 * points; incomplete/tied/empty sets count for neither (a 0-0 placeholder row
 * never awards a set).
 */
export function deriveSetsWon(setScores?: SetScore[] | null): SetsWon {
  const result: SetsWon = { home: 0, away: 0 };
  for (const set of setScores || []) {
    const home = Number(set?.home);
    const away = Number(set?.away);
    if (!Number.isFinite(home) || !Number.isFinite(away)) continue;
    if (home > away) result.home += 1;
    else if (away > home) result.away += 1;
  }
  return result;
}

/** "25-20, 23-25, 25-18" — the compact set line shown under a match score. */
export function formatSetLine(setScores?: SetScore[] | null): string {
  return (setScores || [])
    .filter((s) => Number.isFinite(Number(s?.home)) && Number.isFinite(Number(s?.away)))
    .map((s) => `${Number(s.home)}-${Number(s.away)}`)
    .join(', ');
}
